import gsap from 'gsap'

const handleHideForm = () => {
    gsap.to('.wishlist-overview', {x:"0%"})
    gsap.to('.form-wrapper', {x:"100%"})
}

export default handleHideForm